const STORAGE_KEY = 'cp.schoolNoticeSeen.v1';
const HIDE_TODAY_KEY = 'cp.schoolNoticeHideToday.v1';

type AckMap = Record<string, Record<string, string>>;
/** scope → noticeId → YYYY-MM-DD (로컬 달력) */
type HideTodayMap = Record<string, Record<string, string>>;

function readAll(): AckMap {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const o = JSON.parse(raw) as unknown;
    return o && typeof o === 'object' ? (o as AckMap) : {};
  } catch {
    return {};
  }
}

function writeAll(map: AckMap): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    /* noop */
  }
}

function readHideToday(): HideTodayMap {
  try {
    const raw = window.localStorage.getItem(HIDE_TODAY_KEY);
    if (!raw) return {};
    const o = JSON.parse(raw) as unknown;
    return o && typeof o === 'object' ? (o as HideTodayMap) : {};
  } catch {
    return {};
  }
}

function writeHideToday(map: HideTodayMap): void {
  try {
    window.localStorage.setItem(HIDE_TODAY_KEY, JSON.stringify(map));
  } catch {
    /* noop */
  }
}

/** 로컬 타임존 기준 오늘 (YYYY-MM-DD) */
export function schoolNoticeLocalTodayIso(): string {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** 저장된 updated_at ISO와 같으면 해당 공지는 이미 확인한 것으로 간주 */
export function getSchoolNoticeAckUpdatedAt(workspaceId: string, noticeId: string): string | null {
  const sid = String(workspaceId ?? '').trim();
  const nid = String(noticeId ?? '').trim();
  if (!sid || !nid) return null;
  const all = readAll();
  return all[sid]?.[nid] ?? null;
}

export function setSchoolNoticeAck(workspaceId: string, noticeId: string, updatedAtIso: string): void {
  const sid = String(workspaceId ?? '').trim();
  const nid = String(noticeId ?? '').trim();
  const ts = String(updatedAtIso ?? '').trim();
  if (!sid || !nid || !ts) return;
  const all = readAll();
  if (!all[sid]) all[sid] = {};
  all[sid][nid] = ts;
  writeAll(all);
}

/** 「오늘 보이지 않기」 — 로그인 ack 초기화와 무관하게 당일만 숨김 */
export function setSchoolNoticeHideToday(workspaceId: string, noticeId: string): void {
  const sid = String(workspaceId ?? '').trim();
  const nid = String(noticeId ?? '').trim();
  if (!sid || !nid) return;
  const all = readHideToday();
  if (!all[sid]) all[sid] = {};
  all[sid][nid] = schoolNoticeLocalTodayIso();
  writeHideToday(all);
}

export function isSchoolNoticeHiddenToday(workspaceId: string, noticeId: string): boolean {
  const sid = String(workspaceId ?? '').trim();
  const nid = String(noticeId ?? '').trim();
  if (!sid || !nid) return false;
  const stored = readHideToday()[sid]?.[nid];
  if (!stored) return false;
  return stored === schoolNoticeLocalTodayIso();
}

/** 로그인마다 공지를 다시 띄우기 위해 확인 기록 삭제 (오늘 숨김은 유지) */
export function clearSchoolNoticeAcks(workspaceId?: string): void {
  const sid = String(workspaceId ?? '').trim();
  if (!sid) {
    writeAll({});
    return;
  }
  const all = readAll();
  if (!all[sid]) return;
  delete all[sid];
  writeAll(all);
}
